module.exports = __webpack_public_path__ + "static/img/Azulix-O-MF-Forte.cb2854f.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/Azulix-O-MF-Forte.svg
// module id = vJrV
// module chunks = 1